import { useSetRecoilState } from 'recoil'

import { authenStore, PermissionFuncInfo } from './authenStore'

type ProfileParamType = {
    academicPositionID: number | null
    academicPositionName_en: string | null
    academicPositionName_th: string | null
    academicPositionOther: string | null
    email: string | null
    facultyID: number | null
    facultyName_en: string | null
    facultyName_th: string | null
    fax: string | null
    homePhone: string | null
    irb: number
    mobilePhone: string | null
    name_en: string
    name_th: string
    titleNameID: number | null
    titleNameOther: string | null
    titleName_en: string | null
    titleName_th: string | null
    userGroupId: number
    userGroupName_en: string
    userGroupName_th: string
    userId: number | null
    username: string
    image_path: string
    permission: Array<PermissionFuncInfo>
    isPhD: boolean | null
    only_name_en: string | null
    only_name_th: string | null
    isCunet: boolean | null
    titleNameOther_th: string | null
    titleNameOther_en: string | null
    academicPositionOther_th: string | null
    academicPositionOther_en: string | null
}

const useAuthenAction = () => {
    const setAuthenStore = useSetRecoilState(authenStore)

    const setProfile = (value: ProfileParamType) => {
        setAuthenStore((prevState) => ({
            ...prevState,
            profile: {
                ...value,
                image_path: value.image_path ? value.image_path : null,
            },
        }))
    }

    const setImageProfile = (path: string) => {
        setAuthenStore((prevState) => ({
            ...prevState,
            profile: {
                ...prevState.profile,
                image_path: path,
            },
        }))
    }

    return {
        setProfile,
        setImageProfile,
    }
}

export default useAuthenAction
